import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { toast } from 'react-toastify';
import ImageModalEquip from '../Modal/ImageModalProd';
import { decryptToken } from '../utils/getToken';


const SliderModal = ({ isOpen, setIsOpen, data, setData, sliderFetch }) => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [productOptions, setProductOptions] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [showBackgroundModal, setShowBackgroundModal] = useState(false);
    const [images, setImages] = useState([]);
    const [error, setError] = useState(false);
    const token = decryptToken("accessToken") || ""

    const fetchImages = async () => {
        try {
            const res = await fetch(`${url}/api/images/${isLoggedIn.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${url}/grouped-product/search-all-products/${isLoggedIn.main_id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const res = await response.json();

            const options = res.map((product) => ({
                value: product.product_id,     // or product.id
                label: product.title,
                ...product              // 👈 include all product fields here
            }));

            setProductOptions(options);
        } catch (error) {
            console.log(error);
        }
    };

    console.log(data)
    useEffect(() => {
        fetchProducts();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...data, [name]: value };

        // Price validation (after updating the value)
        if (name === "price" || name === "cutOffPrice") {
            const cutOff = parseFloat(updatedData.cutOffPrice);
            const price = parseFloat(updatedData.price);

            if (!isNaN(price) && !isNaN(cutOff) && price > cutOff) {
                setError(true);
            } else {
                setError(false);
            }
        }

        setData(updatedData);
    };

    const handleProductSelect = (selectedOption) => {
        const fullProduct = productOptions.find(p => p.value === selectedOption.value);
        setData({ ...data, product: fullProduct });
    };

    const handleImageSelect = (field, img) => {
        setData((prev) => ({ ...prev, [field]: `${url}${img.url}` }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        const requiredFields = [
            "price",
            "cutOffPrice",
            "slider_name",
            "description",
            "offer_name",
            "image",
            "background_image"
        ];

        const allEmpty = requiredFields.every(
            (field) => !data[field] || data[field].toString().trim() === ""
        );



        if (allEmpty) {
            toast.error("Please fill at least one details.");
            return;
        }

        if (data.cutOffPrice !== "" && data.price === "") {
            toast.error("Enter discounted price")
            return;
        }

        if (parseFloat(data.price) > parseFloat(data.cutOffPrice)) {
            toast.error("Discounted price should be less than Original Price")
            return;
        }

        const payload = {
            ...data,
            user_id: isLoggedIn.main_id,
            user_name: isLoggedIn.full_name,
        };

        const response = await fetch(`${url}/slider${data.id ? `/${data.id}` : ""}`, {
            method: data.id ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        const res = await response.json();
        if (response.ok) {
            toast.success("Slider saved successfully");
            sliderFetch();
            setIsOpen(false);
        } else {
            toast.error("Failed to save slider");
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Slider</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {/* Slider Title */}
                    <div className="oms-form-group">
                        <label htmlFor="slider_name" className="oms-form-label">Slider Title</label>
                        <input
                            type="text"
                            id="slider_name"
                            name="slider_name"
                            value={data.slider_name}
                            onChange={handleChange}
                            placeholder="e.g. Mega Summer Sale"
                        />
                    </div>

                    {/* Description */}
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">Slider Description</label>
                        <input
                            type="text"
                            id="description"
                            name="description"
                            value={data.description}
                            onChange={handleChange}
                            placeholder="Short description for the slider"
                        />
                    </div>

                    {/* Original Price */}
                    <div className="oms-form-group">
                        <label htmlFor="cutOffPrice" className="oms-form-label">Original Price</label>
                        <input
                            type="number"
                            id="cutOffPrice"
                            name="cutOffPrice"
                            value={data.cutOffPrice}
                            onChange={handleChange}
                            placeholder="e.g. 1999"
                        />
                    </div>

                    {/* Discounted Price */}
                    <div className="oms-form-group">
                        <label htmlFor="price" className="oms-form-label">Discounted Price</label>
                        <input
                            type="number"
                            id="price"
                            name="price"
                            value={data.price}
                            onChange={handleChange}
                            placeholder="e.g. 1499"
                        />
                        {
                            error ? <p className='checkpricegreaterthan-slidermodal'>Discounted price should be less than Original Price</p> :
                                null
                        }
                    </div>


                    {/* Offer Tagline */}
                    <div className="oms-form-group">
                        <label htmlFor="offer_name" className="oms-form-label">Offer Tagline</label>
                        <input
                            type="text"
                            id="offer_name"
                            name="offer_name"
                            value={data.offer_name}
                            onChange={handleChange}
                            placeholder="e.g. 25% Off – Limited Time!"
                        />
                    </div>

                    {/* Banner Image Upload */}
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="image" className="oms-form-label">Main Image</label>
                        <button type="button" onClick={() => setShowImageModal(true)}>Upload Main Image</button>
                        <div>
                            {data.image && (
                                <img src={data.image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                            )}
                        </div>
                    </div>

                    {/* Background Image Selection */}
                    <div className="oms-form-group ome-form-button2">
                        <label htmlFor="background_image" className="oms-form-label">Slider Background</label>
                        <button type="button" onClick={() => setShowBackgroundModal(true)}>Select Background</button>
                        <div>
                            {data.background_image && (
                                <img src={data.background_image} alt="Selected" style={{ width: 80, marginTop: 10 }} />
                            )}
                        </div>
                    </div>

                    {/* Product Selection */}
                    <div className="oms-form-group">
                        <label htmlFor="product" className="oms-form-label">Linked Product</label>
                        <Select
                            options={productOptions}
                            value={data.product}
                            onChange={handleProductSelect}
                            placeholder="Search and select a product to link"
                            isClearable
                        />
                    </div>

                    {/* Image Modals */}
                    <ImageModalEquip
                        show={showImageModal}
                        handleClose={() => setShowImageModal(false)}
                        images={images}
                        onImageSelect={(img) => handleImageSelect('image', img)}
                        multiple={false}
                        setImages={setImages}
                    />

                    <ImageModalEquip
                        show={showBackgroundModal}
                        handleClose={() => setShowBackgroundModal(false)}
                        images={images}
                        onImageSelect={(img) => handleImageSelect('background_image', img)}
                        multiple={false}
                        setImages={setImages}
                    />

                    {/* Form Actions */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>

    );
};


export default SliderModal;
